import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/S1.webp',
  './images/S2.webp',
  './images/S3.webp',
  './images/S4.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Shanghai, China’s largest city, is a dynamic blend of futuristic skyscrapers, colonial architecture, and traditional culture.

Top places to visit:

• The Bund – A scenic waterfront area showcasing colonial-era buildings and skyline views.
• Oriental Pearl Tower – Iconic tower offering city panoramas, dining, and a glass-floored skywalk.
• Yu Garden – A classical Chinese garden with pavilions, ponds, and rockeries.
• Nanjing Road – One of the world’s busiest shopping streets.
• Shanghai Tower – The second-tallest building in the world with an amazing observation deck.
• Jade Buddha Temple – A peaceful temple featuring exquisite jade Buddha statues.
• Tianzifang – A lively arts and crafts enclave full of boutiques and cafés.
• Shanghai Museum – A world-class museum of ancient Chinese art and artifacts.
• Disneyland Shanghai – A magical experience for families and theme park lovers.
• Huangpu River Cruise – Stunning night views of Shanghai’s skyline from the water.

Shanghai is also famous for its food scene, from street dumplings to fine dining, blending local flavors with global influence.`,

    zh: `上海是中国最大的城市，以其现代摩天大楼、殖民建筑和传统文化的完美融合而著称。

推荐景点：

• 外滩 – 欣赏中西合璧的建筑群和黄浦江两岸美景。
• 东方明珠塔 – 标志性建筑，可俯瞰城市全景，还有玻璃观光廊。
• 豫园 – 古典园林，亭台楼阁、小桥流水，充满江南韵味。
• 南京路 – 世界最繁忙的购物街之一。
• 上海中心大厦 – 世界第二高楼，拥有观景平台。
• 玉佛寺 – 静谧庄严的佛教圣地，供奉珍贵玉佛。
• 田子坊 – 创意艺术街区，有手工艺品店和特色咖啡馆。
• 上海博物馆 – 收藏丰富的中国古代文物。
• 上海迪士尼乐园 – 全家出游的乐趣天堂。
• 黄浦江夜游 – 夜色中欣赏浦江两岸的灯光和城市天际线。

上海的美食文化同样出彩，从街头小笼包到高档餐厅，应有尽有，满足各类味蕾。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/S2.webp" className="travel-image2" />
          <img src="./images/S1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Shanghai</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Shanghai</h2>
          <p className="carousel-subheading">
            Skyscrapers, heritage streets, world-class shopping, and unforgettable cuisine.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
